"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPlanDetails = exports.sendTags = exports.resetPlanDetails = exports.getActivePlanDetailsSuccess = exports.getActivePlanDetailsRequest = exports.getActivePlanDetailsFailure = exports.SET_PLAN_DETAILS = exports.RESET_PLAN_DETAILS = exports.GET_DIGITAL_PRODUCT_SUCCESS = exports.GET_DIGITAL_PRODUCT_FAILURE = exports.GET_ACTIVE_PRODUCTS_STATUS_SUCCESS = exports.GET_ACTIVE_PLAN_DETAILS_SUCCESS = exports.GET_ACTIVE_PLAN_DETAILS_REQUEST = exports.GET_ACTIVE_PLAN_DETAILS_FAILURE = exports.CALL_TEALIUM = void 0;
var _constants = require("../constants");
var CALL_TEALIUM = 'CALL_TEALIUM';
exports.CALL_TEALIUM = CALL_TEALIUM;
var SET_PLAN_DETAILS = "@".concat(_constants.PKG_NAME, "/SET_PLAN_DETAILS");
exports.SET_PLAN_DETAILS = SET_PLAN_DETAILS;
var GET_ACTIVE_PLAN_DETAILS_REQUEST = "@".concat(_constants.PKG_NAME, "/GET_ACTIVE_PLAN_DETAILS_REQUEST");
exports.GET_ACTIVE_PLAN_DETAILS_REQUEST = GET_ACTIVE_PLAN_DETAILS_REQUEST;
var GET_ACTIVE_PLAN_DETAILS_SUCCESS = "@".concat(_constants.PKG_NAME, "/GET_ACTIVE_PLAN_DETAILS_SUCCESS");
exports.GET_ACTIVE_PLAN_DETAILS_SUCCESS = GET_ACTIVE_PLAN_DETAILS_SUCCESS;
var GET_ACTIVE_PLAN_DETAILS_FAILURE = "@".concat(_constants.PKG_NAME, "/GET_ACTIVE_PLAN_DETAILS_FAILURE");

/* eslint max-len: "off" */
exports.GET_ACTIVE_PLAN_DETAILS_FAILURE = GET_ACTIVE_PLAN_DETAILS_FAILURE;
var GET_ACTIVE_PRODUCTS_STATUS_SUCCESS = "@".concat(_constants.seviceHeaderWidget, "/GET_ACTIVE_PRODUCTS_STATUS_SUCCESS");

/* eslint max-len: "off" */
exports.GET_ACTIVE_PRODUCTS_STATUS_SUCCESS = GET_ACTIVE_PRODUCTS_STATUS_SUCCESS;
var GET_DIGITAL_PRODUCT_SUCCESS = "@".concat(_constants.seviceHeaderWidget, "/GET_DIGITAL_PRODUCT_SUCCESS");
exports.GET_DIGITAL_PRODUCT_SUCCESS = GET_DIGITAL_PRODUCT_SUCCESS;
var GET_DIGITAL_PRODUCT_FAILURE = "@".concat(_constants.seviceHeaderWidget, "/GET_DIGITAL_PRODUCT_FAILURE");
exports.GET_DIGITAL_PRODUCT_FAILURE = GET_DIGITAL_PRODUCT_FAILURE;
var RESET_PLAN_DETAILS = "@".concat(_constants.PKG_NAME, "/RESET_PLAN_DETAILS");
exports.RESET_PLAN_DETAILS = RESET_PLAN_DETAILS;
var sendTags = function sendTags(taggingValue, taggingType) {
  return {
    type: CALL_TEALIUM,
    payload: {
      taggingValue: taggingValue,
      taggingType: taggingType
    }
  };
};
exports.sendTags = sendTags;
var setPlanDetails = function setPlanDetails(payload) {
  return {
    type: SET_PLAN_DETAILS,
    payload: payload
  };
};
exports.setPlanDetails = setPlanDetails;
var resetPlanDetails = function resetPlanDetails() {
  return {
    type: RESET_PLAN_DETAILS
  };
};
exports.resetPlanDetails = resetPlanDetails;
var getActivePlanDetailsRequest = function getActivePlanDetailsRequest() {
  return {
    type: GET_ACTIVE_PLAN_DETAILS_REQUEST
  };
};
exports.getActivePlanDetailsRequest = getActivePlanDetailsRequest;
var getActivePlanDetailsSuccess = function getActivePlanDetailsSuccess(payload) {
  return {
    type: GET_ACTIVE_PLAN_DETAILS_SUCCESS,
    payload: payload
  };
};
exports.getActivePlanDetailsSuccess = getActivePlanDetailsSuccess;
var getActivePlanDetailsFailure = function getActivePlanDetailsFailure() {
  return {
    type: GET_ACTIVE_PLAN_DETAILS_FAILURE
  };
};
exports.getActivePlanDetailsFailure = getActivePlanDetailsFailure;